import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/medicamento-nao-padronizado`

    return {
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
    }
}